import React, { useEffect, useState } from 'react';
import { Wrapper, Content, BanerImg } from '../Baner/Baner.styles';

import baner1 from '../../images/banery/baner-top_siatka_2027.jpg'
import baner2 from '../../images/banery/baner-top_przypon_2027.jpg'
import baner3 from '../../images/banery/baner-top_zylki_2027.jpg'
import baner4 from '../../images/banery/baner-top_kolowrotek_2027.jpg'
import baner5 from '../../images/banery/baner-top_haczyk_2027.jpg'

import {Link} from 'react-router-dom';

const baners = [baner1, baner2, baner3, baner4, baner5]
const banerLinks = [
    '/Products/40',
    '/Products/32',
    '/Product/451',
    '/Product/436',
    '/Products/31',
]
const delay = 6000 // miliseconds


const Baner = () => {
    const [banerId, setBanerId] = useState(0)    
    useEffect( () => 
        setTimeout(() => 
            setBanerId(banerId+1 < baners.length ? banerId+1 : 0)
        , delay)
    )

    return (
        <Wrapper>
            <Link to={banerLinks[banerId]} style={{ textDecoration: 'none' }}>
                <Content>
                    <BanerImg src={baners[banerId]} alt='baner-image'></BanerImg>
                </Content>
            </Link>
        </Wrapper>
    )
}

export default Baner;